import { createReduxModule } from "hooks-for-redux";

export const [client, {setClient, resetClient}, clientStore] = createReduxModule(
  "client",
  {},
  {
    setClient:(client, clientObject) => {client = clientObject; return client},
    resetClient:(client, clientObject) => {client = {}; return client}
  }
);